import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner";

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:bg-black/60 group-[.toaster]:backdrop-blur-xl group-[.toaster]:border-white/10 group-[.toaster]:shadow-2xl group-[.toaster]:text-white group-[.toaster]:rounded-2xl",
          description: "group-[.toast]:text-gray-400 font-medium",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toaster]:border-green-500/20 group-[.toaster]:bg-green-500/10",
          error: "group-[.toaster]:border-red-500/20 group-[.toaster]:bg-red-500/10",
        },
      }}
      {...props} />
  );
}

export { Toaster }
